<div class="tools-container" [formGroup]="toolsFormGroup">
  @if (isFieldVisible('font_family')) {
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.TEXT_TOOLS.FONT' | translate }}</mat-label>
      <mat-select [formControl]="fontFamilyControl">
        <mat-option [value]="''">{{ 'PRESENTER.TEXT_TOOLS.DEFAULT' | translate }}</mat-option>
        @for (font of fontFamilyOptions; track font) {
          <mat-option [value]="font" [style.font-family]="font">{{ font }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (isFieldVisible('font_size') || isFieldVisible('font_weight')) {
    <div class="form-field-row">
      @if (isFieldVisible('font_size')) {
        <mat-form-field>
          <mat-label>{{ 'PRESENTER.TEXT_TOOLS.SIZE' | translate }}</mat-label>
          <input matInput type="number" [formControl]="fontSizeControl" placeholder="16" min="8" max="200" />
          <span matTextSuffix>{{ 'PX' | translate }}</span>
        </mat-form-field>
      }

      @if (isFieldVisible('font_weight')) {
        <mat-form-field>
          <mat-label>{{ 'PRESENTER.TEXT_TOOLS.WEIGHT' | translate }}</mat-label>
          <mat-select [formControl]="fontWeightControl">
            @for (weight of fontWeightOptions; track weight.value) {
              <mat-option [value]="weight.value">{{ weight.label | translate }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  }

  @if (isFieldVisible('font_style')) {
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.TEXT_TOOLS.STYLE' | translate }}</mat-label>
      <mat-select [formControl]="fontStyleControl">
        @for (style of fontStyleOptions; track style.value) {
          <mat-option [value]="style.value">{{ style.label | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (isFieldVisible('text_align')) {
    <mat-form-field>
      <mat-label>{{ 'PRESENTER.TEXT_TOOLS.ALIGNMENT' | translate }}</mat-label>
      <mat-select [formControl]="textAlignControl">
        @for (align of textAlignOptions; track align.value) {
          <mat-option [value]="align.value">{{ align.label | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (isFieldVisible('color')) {
    <gb-token-color-picker
      circleDiameter="38px"
      [control]="colorControl"
      labelTranslateKey="PRESENTER.TEXT_TOOLS.COLOR"
      cpPosition="right"
      [showDropdown]="true"
    ></gb-token-color-picker>
  }
</div>
